<template>
  <MfaController
    :componentsUnderControl="componentsUnderControl"
    :controllingQueryParams="controllingQueryParams"
    :errorMessage="errorMessage"
    :factors="factors"
    :mfaType="mfaType"
    @onError="handleError"
    @onResetErrorMessage="$emit('resetErrorMessage')"
    @onSuccess="handleSuccess"
    :shouldHideEmailBadge="shouldHideEmailBadge"
  />
</template>

<script>
// Components
import DuoUserLoginHandler from 'client/containers/user/MfaComponents/LoginHandlers/DuoUserLoginHandler.vue';
import MfaController from 'client/containers/user/MfaComponents/MfaController.vue';
import PushUserLoginHandler from 'client/containers/user/MfaComponents/LoginHandlers/PushUserLoginHandler.vue';
import TotpUserLoginHandler from 'client/containers/user/MfaComponents/LoginHandlers/TotpUserLoginHandler.vue';
import WebAuthnUserLoginHander from 'client/containers/user/MfaComponents/LoginHandlers/WebAuthnUserLoginHandler.vue';

// Utils
import LocalStorageService from 'client/util/LocalStorageService';
import Util from 'client/util/Util';

// Constants
import { LocalStorageConsts, LoginConsts } from 'client/util/Constants';
import RequestError from 'client/services/response/RequestError';

const { previousMfaMethod } = LocalStorageConsts;
const { responseMessages } = LoginConsts;
const { loginError } = responseMessages;

export default {
  name: 'UserLoginMfaController',

  LocalStorageService,
  redirect: Util.redirect,

  components: {
    MfaController,
  },

  props: {
    controllingQueryParams: {
      type: Object,
      default: () => ({}),
    },
    errorMessage: {
      type: String,
      default: '',
    },
    factors: {
      type: Array,
      required: true,
    },
    mfaType: {
      type: String,
      required: true,
    },
    redirectTo: {
      type: String,
      default: '',
    },
    shouldHideEmailBadge: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    componentsUnderControl() {
      return [
        {
          id: 'duo',
          componentName: DuoUserLoginHandler.name,
        },
        {
          id: 'totp',
          componentName: TotpUserLoginHandler.name,
        },
        {
          id: 'webauthn',
          componentName: WebAuthnUserLoginHander.name,
        },
        {
          id: 'push',
          componentName: PushUserLoginHandler.name,
        },
      ];
    },
  },

  created() {
    // Clear any error that may have occurred during email/password entry
    if (this.errorMessage) {
      this.$emit('resetErrorMessage');
    }
  },

  methods: {
    handleError(error) {
      if (error instanceof RequestError) {
        // Indicates invalid otp attempts > max attempts
        if (error.status === 403) {
          this.$emit('changeComponent', 'password', error.message);
        }
        this.$emit('setErrorMessage', error.message);
      } else {
        this.$emit('setErrorMessage', loginError);
      }
    },

    handleSuccess() {
      this.$emit('rememberUserEmail');
      this.$options.LocalStorageService.setItem(previousMfaMethod, this.mfaType);
      this.$options.redirect(this.redirectTo);
    },
  },
};
</script>
